var exports = {
  "Lw": "UploadDropModal.module__overlay___VDFIaV",
  "r3": "UploadDropModal.module__dialog___VDFIaV",
  "ew": "UploadDropModal.module__dialogIconCircle___VDFIaV",
  "aY": "UploadDropModal.module__dialogIcon___VDFIaV",
  "tp": "UploadDropModal.module__dialogTextBlock___VDFIaV",
  "nl": "UploadDropModal.module__dialogTitle___VDFIaV",
  "HP": "UploadDropModal.module__dialogDescription___VDFIaV",
  "ly": "UploadDropModal.module__statusBanner___VDFIaV",
  "zm": "UploadDropModal.module__statusBannerActive___VDFIaV",
  "Sl": "UploadDropModal.module__statusBannerDefault___VDFIaV",
  "UX": "UploadDropModal.module__statusIndicator___VDFIaV",
  "Ie": "UploadDropModal.module__statusIndicatorActive___VDFIaV",
  "I8": "UploadDropModal.module__statusIcon___VDFIaV",
};

module.exports = exports;
